export default "__VITE_ASSET__DwyaL5Ih__"